import { MoonIcon, PartlyCloudyDayIcon, SunnyIcon, SunnySnowingIcon } from '@dreryk/react-components';

import { DosageTimeOfDay } from '~libs.shared.prescription';

import { StyledTimeOfDayIcon } from './TimeOfDayIcon.styled';

const TIME_OF_DAY_ICONS: Record<DosageTimeOfDay, () => JSX.Element> = {
   /* eslint-disable sort-keys-fix/sort-keys-fix */
   MORNING: SunnySnowingIcon,
   NOON: SunnyIcon,
   AFTERNOON: PartlyCloudyDayIcon,
   EVENING: MoonIcon,
   /* eslint-enable sort-keys-fix/sort-keys-fix */
};

type TimeOfDayIconProps = {
   readonly timeOfDay: DosageTimeOfDay;
};

export const TimeOfDayIcon = (props: TimeOfDayIconProps): JSX.Element => {
   const Icon = TIME_OF_DAY_ICONS[props.timeOfDay];

   return (
      <StyledTimeOfDayIcon>
         <Icon />
      </StyledTimeOfDayIcon>
   );
};
